import { useState } from "react"
import { useLocation } from "wouter"

const videos = [
  { src: "/Swift/002_distortio_effect.mp4", title: "Distortion Effect" },
  { src: "/Swift/003_visionpro.mp4", title: "Vision Pro" },
  { src: "/Swift/004_particle_effect.mp4", title: "Particle Effect" },
  { src: "/Swift/006_spline_ai_2.mp4", title: "Spline AI" },
  { src: "/Swift/007_stack_card.mp4", title: "Stack Card" },
  { src: "/Swift/008_album.mp4", title: "Album" },
]

export default function SwiftWorks() {
  const [lightbox, setLightbox] = useState(null)
  const [, navigate] = useLocation()

  return (
    <div className="page-panel">
      <div className="panel-inner">

        <div className="panel-header">
          <div className="panel-tag">
            <button className="back-btn" onClick={() => navigate("/work")}>← Work</button>
          </div>
          <h2 className="panel-title">SwiftUI<br />+ ProtoPie</h2>
          <p className="panel-subtitle">
            Exploring native SwiftUI development and advanced ProtoPie prototyping —
            high-fidelity, production-grade interactions that bridge design and engineering.
          </p>
        </div>

        <div className="swift-grid">
          {videos.map((v, i) => (
            <div key={i} className="swift-item" onClick={() => setLightbox(i)}>
              <video
                src={v.src}
                autoPlay
                loop
                muted
                playsInline
                className="swift-video"
              />
              <div className="swift-item-label">{v.title}</div>
            </div>
          ))}
        </div>

      </div>

      {lightbox !== null && (
        <div className="lightbox" onClick={() => setLightbox(null)}>
          <button className="lightbox-close" onClick={() => setLightbox(null)}>✕</button>
          <button
            className="lightbox-prev"
            onClick={(e) => { e.stopPropagation(); setLightbox((lightbox - 1 + videos.length) % videos.length) }}
          >‹</button>
          <div className="lightbox-content" onClick={(e) => e.stopPropagation()}>
            <video
              src={videos[lightbox].src}
              autoPlay
              loop
              muted
              playsInline
              style={{ maxWidth: "100%", maxHeight: "80vh", display: "block" }}
            />
            <div className="lightbox-title">{videos[lightbox].title}</div>
          </div>
          <button
            className="lightbox-next"
            onClick={(e) => { e.stopPropagation(); setLightbox((lightbox + 1) % videos.length) }}
          >›</button>
          <div className="lightbox-counter">{lightbox + 1} / {videos.length}</div>
        </div>
      )}
    </div>
  )
}
